import { Link } from 'react-router-dom';
import { getPendingMemberDisplayName } from '../../utils/waitlist';

export default function TeamActionRow({ action }) {
  const { id, teamId, teamName, data, type } = action;

  if (type === 'refundRequest') {
    const { eventId, ticketId } = data;
    const label = `Refund requested for event ${eventId} (ticket ${ticketId}) on “${teamName}”.`;
    const link = `/teams/${teamId}/calendar?event=${eventId}`;
    return (
      <Link to={link} className="invite-row invite-link">
        <span className="invite-text">{label}</span>
        <span className="invite-arrow">→</span>
      </Link>
    );
  }

  if (type === 'roleRequest') {
    const { eventId, eventName, roleName, requestedByName } = data;
    const label = `${requestedByName || 'A member'} requested “${roleName || 'role'}” for ${eventName || 'an event'} on “${teamName}”.`;
    const link = `/teams/${teamId}/calendar?event=${eventId}&panel=roles`;
    return (
      <Link to={link} className="invite-row invite-link">
        <span className="invite-text">{label}</span>
        <span className="invite-arrow">→</span>
      </Link>
    );
  }

  if (type === 'membershipRequest') {
    const { requestedBy, requestedByName, message } = data;
    const label = `${requestedByName || 'A member'} requested a membership change on “${teamName}”. ${message || ''}`.trim();
    const params = new URLSearchParams({
      panel: 'members',
      member: requestedBy || '',
      request: 'membership',
    });
    const link = `/teams/${teamId}?${params.toString()}`;
    return (
      <Link to={link} className="invite-row invite-link">
        <span className="invite-text">{label}</span>
        <span className="invite-arrow">→</span>
      </Link>
    );
  }

  if (type === 'learnToRowApproval') {
    const displayName = getPendingMemberDisplayName(data);
    const params = new URLSearchParams({ panel: 'learnToRowWaitlist' });
    const link = `/teams/${teamId}?${params.toString()}`;
    const label = `${displayName} is waiting for Learn to Row approval on “${teamName}”.`;
    return (
      <Link to={link} className="invite-row invite-link">
        <span className="invite-text">{label}</span>
        <span className="invite-arrow">→</span>
      </Link>
    );
  }

  if (type === 'learnToSailApproval') {
    const displayName = getPendingMemberDisplayName(data);
    const params = new URLSearchParams({ panel: 'learnToSailWaitlist' });
    const link = `/teams/${teamId}?${params.toString()}`;
    const label = `${displayName} is waiting for Learn to Sail approval on “${teamName}”.`;
    return (
      <Link to={link} className="invite-row invite-link">
        <span className="invite-text">{label}</span>
        <span className="invite-arrow">→</span>
      </Link>
    );
  }

  // default: pending join request
  const displayName = getPendingMemberDisplayName(data) || 'Someone';

  const label = `${displayName} requested to join “${teamName}“. Click here to approve or reject.`;
  const params = new URLSearchParams({ panel: 'pendingMembers' });
  if (id && !String(id).startsWith('legacy:')) params.set('request', String(id));
  const link = `/teams/${teamId}?${params.toString()}`;

  return (
    <Link to={link} className="invite-row invite-link">
      <span className="invite-text">{label}</span>
      <span className="invite-arrow">→</span>
    </Link>
  );
}
